import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import * as RouterActions from '../actions/router.actions';

@Injectable()
export class RouterEffects {
  private _actions$ = inject(Actions);
  private _router = inject(Router);
  private _location = inject(Location);

  navigate$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(RouterActions.GO),
        map((action: RouterActions.Go) => action.payload),
        tap(({ path, matrixParams, query: queryParams, extras }) => {
          const pathArray = matrixParams ? [...path, { ...matrixParams }] : [...path];
          this._router.navigate(pathArray, { queryParams, ...extras });
        })
      ),
    { dispatch: false }
  );

  navigateBack$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(RouterActions.BACK),
        tap(() => this._location.back())
      ),
    { dispatch: false }
  );

  navigateForward$ = createEffect(
    () =>
      this._actions$.pipe(
        ofType(RouterActions.FORWARD),
        tap(() => this._location.forward())
      ),
    { dispatch: false }
  );
}
